module.exports = __webpack_public_path__ + "img/ck-five.dc5fd554.png";